import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import connect from '../views/axios/axios.auth';
import Card from './card.component';
import Modal from './modal/modal.component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import {
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDebounceValue } from './debounceSearch.component';
import { Pagination, Row, Col } from 'react-bootstrap';


const customStyles = {
rows: {
  style: {
    minHeight: '72px', // override the row height
  }
},
headCells: {
  style: {
    paddingLeft: '8px', // override the cell padding for head cells
    paddingRight: '8px',
  },
},
cells: {
  style: {
    paddingLeft: '8px', // override the cell padding for data cells
    paddingRight: '8px',
  },
},
};

const ClienteComponentModal = ({ onSelected, visibleOpen, onClose }) => {

  const [listado, setListado] = useState([]);
  const [pending, setPending] = useState(true);
  const [visible, setVisible] = useState(visibleOpen);
 const [pagination, setPagination] = useState({
      pagination: 1,
      isLastPage: false,
      lastPage: 0,
  });

  const [findText, setFindText] = useState('');
  const deboncedValue = useDebounceValue(findText, 1500);


    useEffect(() => {
      if (deboncedValue.trim() !== '') {
        listadoClientes({
          pagination: 1,
          findText:findText,
        });
      } else {
        listadoClientes({
          pagination: 1,
        });
      }
   }, [deboncedValue])

  useEffect(() => {
    listadoClientes({ pagination: 1});
  },[])

  useEffect(() => {
    setVisible(visibleOpen);
  },[visibleOpen])

  const clientesSeleccionados = (row) => {
    onSelected(row);
  }

  const listadoClientes = (data) => {
    connect.post(`/cliente/v2`, data)
    .then((response) => {
      setListado(response.data.client);
      setPagination({
        pagination: response.data.pagination,
        isLastPage: response.data.is_last_page,
        lastPage: response.data.last_page,
      })
      setPending(false);
    })
  }

  const columnsClientes = [
    {
      name: 'Rut',
      selector: 'rut',
      sortable: true,
    },
    {
      name: 'Nombre completo',
      selector: 'name',
      sortable: true,
    },
    {
      name: 'Seleccionar',
      sortable: false,
      right: true,
      cell: row => (
        <button 
          onClick={() => clientesSeleccionados(row)}
          type="button"
          className="btnx btnx-warn m-1"
        >
            <FontAwesomeIcon icon={faCheck} />
        </button>
      )
    },
  ];

  
  const nextPage = () => {
    if (!pagination.isLastPage) {
      listadoClientes({
        pagination: pagination.pagination + 1,
      });
    }
  }

  const prevPage = () => {
    if (pagination.pagination > 1) {
      listadoClientes({
          pagination: pagination.pagination - 1,
        });
    }
  }

  const lastPage = () => {
    listadoClientes({
      pagination: pagination.lastPage,
    });
  }

  const firstPage = () => {
    listadoClientes({
      pagination: 1,
    });
  }

  const buscador = (e) => {
    setFindText(e.target.value);
  }

  return (
    <>
    <Modal show={visible}>
      <Card>
          <h3>Clientes</h3>
          <DataTableExtensions
           columns={columnsClientes}
           data={listado}
           export={false}
           print={false}
           filter={false}
          >
              <DataTable
              noHeader={true}
              customStyles={customStyles}
              dense={true}
              pagination={false}
              progressPending={pending}
              progressComponent={
                <h3>Cargando...</h3>
              }
              noDataComponent={"No existen datos asociados a la busqueda."}
              subHeader={true}
              subHeaderComponent={
                <div style={{ width: '100%' }}>
                  <input onChange={(e) => buscador(e)} className="form-control" name="buscador" type="text" placeholder="Buscar por nombre cliente..."/>  
                </div>
              }
            />
          </DataTableExtensions>

          <Row>
            <Col className="d-flex justify-content-end">
              <Pagination>
                <Pagination.First
                   onClick={firstPage}
                   disabled={pagination.pagination === 1 ? true : false}
                />
                <Pagination.Prev
                   onClick={prevPage}
                   disabled={pagination.pagination === 1 ? true : false}
                />
                <Pagination.Next 
                  onClick={nextPage}
                  disabled={pagination.isLastPage}
                />
                <Pagination.Last
                  onClick={lastPage}
                  disabled={pagination.isLastPage}
                />
              </Pagination>
           </Col>
          </Row>
          <button 
              onClick={() => onClose()}
              type="button"
              className="btnx btnx-warn mr-1"
              >
                  Cerrar
          </button>

          
        </Card>
      </Modal>
   </>
  )
}

export default ClienteComponentModal;